import { formatHotelOrderStayRange } from '@utils/format-hotel-stay'

export function resolveOrdersList(payload) {
  const payloadData = payload && payload.data ? payload.data : {}
  let ordersList = payloadData.orders || payload.orders || []

  if ((!ordersList || !ordersList.length) && payload) {
    if (Array.isArray(payload) && payload.length) ordersList = payload
    else if (payload.bookings || payload.uuid || payload.displayId) ordersList = [payload]
    else if (payload.data && payload.data.order) ordersList = [payload.data.order]
  }

  return Array.isArray(ordersList) ? ordersList : []
}

function mapGuestsToPets(guests) {
  if (!Array.isArray(guests) || !guests.length) return []

  return guests.map((g) => {
    const categoryInfo = g.category && typeof g.category === 'object' ? g.category : null
    const categoryTitle = categoryInfo ? categoryInfo.title : g.category || null
    const categoryTags = categoryInfo && Array.isArray(categoryInfo.tags) ? categoryInfo.tags : Array.isArray(g.categoryTags) ? g.categoryTags : []
    return {
      id: g.id,
      name: g.name || null,
      category: categoryInfo || (categoryTitle ? { title: categoryTitle, tags: categoryTags } : null),
      categoryTags,
      isAssessed: g.isAssessed || false,
      isEvaluationRequired: !!g.isEvaluationRequired,
      imgUrl: g.imgUrl || null,
    }
  })
}

function mapBookingsToSelectedRooms(bookings) {
  const grouped = bookings.reduce((acc, b) => {
    const key = b.roomId
    if (!acc[key]) acc[key] = { sample: b, items: [] }
    acc[key].items.push(b)
    return acc
  }, {})

  return Object.keys(grouped).map((key) => {
    const sample = grouped[key].sample || {}
    const items = grouped[key].items || []
    const categories = Array.isArray(sample.categories)
      ? sample.categories
      : Array.isArray(sample.roomTypeCategories)
        ? sample.roomTypeCategories.map((title) => ({ title }))
        : []

    const date = items.map((b) => ({
      day: b.date || null,
      roomName: b.title || null,
      quantity: b.qty != null ? b.qty : null,
      price: b.price != null ? b.price : null,
      note: b.note || null,
    }))

    return {
      name: sample.title || null,
      category: Array.isArray(categories) && categories.length ? categories.map((c) => c.title).join(', ') : null,
      limit: sample.limit != null ? sample.limit : null,
      date: date || [],
    }
  })
}

function mapOrderToAccommodation(orderObj, showCheckoutDate = 1) {
  const petsForOrder = mapGuestsToPets(orderObj.guests)
  const checkInDate = orderObj.checkinDate || orderObj.startDate || null
  const checkOutDate = orderObj.checkoutDate || orderObj.endDate || null
  const base = {
    startDate: checkInDate,
    endDate: checkOutDate,
    checkInDate,
    checkOutDate,
    nights: orderObj.nights,
    stayRange: formatHotelOrderStayRange(orderObj, showCheckoutDate),
    status: orderObj.status || null,
    pets: petsForOrder || [],
  }

  if (orderObj.bookings && Array.isArray(orderObj.bookings) && orderObj.bookings.length) {
    const selectedRoom = mapBookingsToSelectedRooms(orderObj.bookings)
    return {
      ...base,
      selectedRoom: selectedRoom.length ? selectedRoom : [],
    }
  }

  return {
    ...base,
    selectedRoom: [],
  }
}

export function mapOrdersToAccommodation(ordersList, showCheckoutDate = 1) {
  if (!ordersList || !ordersList.length) {
    return { subOrders: [], accommodationInfo: [], petsInfo: [] }
  }

  const accommodationInfo = ordersList.map((order) => mapOrderToAccommodation(order, showCheckoutDate))

  return {
    subOrders: ordersList,
    accommodationInfo,
    petsInfo: accommodationInfo.length ? accommodationInfo[0].pets || [] : [],
  }
}
